"use client";
import { CourseVideo } from "@/components/CourseContent/ContentOverview/types";
import VideoPlayer from "@/components/VideoPlayer";
import useTranslations from "@/i18n/useTranslations";

type SideRailVideoPlayerProps = {
  title?: string;
  video?: CourseVideo;
  thumbnail?: string;
};

export default function SideRailVideoPlayer({
  title,
  video,
  thumbnail,
}: SideRailVideoPlayerProps) {
  const t = useTranslations("Program");
  return (
    <div>
      {(video && video.src) || thumbnail ? (
        <div className="flex flex-col gap-4">
          <VideoPlayer
            videoClassName="w-full h-[243px]"
            videoContainerClassName="w-full h-[243px] bg-black rounded-xl"
            title={t("programOverviewVideo")}
            videoUrl={video?.src || "null"}
            videoThumbnail={thumbnail}
            isSideRail
          />
          <p className="block md:hidden text-primary-500 tracking-tight font-black text-2xl m-0">
            {title}
          </p>
        </div>
      ) : (
        <p className="text-primary-500 tracking-tight font-black text-3xl m-0">
          {title}
        </p>
      )}
    </div>
  );
}
